import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { interval: Number };

  connect() {
    this.timer = setInterval(() => this.#frame?.reload(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  get #frame() {
    return this.element.closest('turbo-frame');
  }
}
